import { Component, Input, ElementRef, ViewChild, AfterViewInit, Renderer2 } from "@angular/core";
import { Statuses } from "./constants/status.constants";

@Component({
  selector: "cmx-status-indicator",
  styleUrls: ["../../scssv4/cmx-components/cmx-status-indicator/v4/cmx-status-indicator.component.scss"],
  templateUrl: "./cmx-status-indicator.component.html",
})
export class CmxStatusIndicatorComponent implements AfterViewInit {
  @Input()
  set type($value: Statuses) {
    if ($value != undefined) {
      this._type = $value;
      this.setStatusStyle();
    }
  }
  get type(): Statuses {
    return this._type;
  }
  @Input()
  set label($value: string) {
    if ($value != undefined) {
      this._label = $value;
    }
  }
  get label(): string {
    return this._label;
  }

  @ViewChild("statusFlag", { static: false }) statusFlag!: ElementRef;

  private _type: Statuses = Statuses.DISABLED;
  private _label: string = "";

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    //
  }

  public ngAfterViewInit(): void {
    this.setStatusStyle();
  }

  private setStatusStyle(): void {
    setTimeout(() => {
      this.renderer?.setAttribute(
        this.statusFlag?.nativeElement,
        "class",
        "cmx-flag-status cmx-flag-status--" + this.type
      );
    }, 500);
  }
}
